export const enum ProductDetailsModalTrackingEvent {
  OPEN_IMAGE_CLICKED = 'product-details-modal-open-image-clicked',
  ARROW_CLICKED = 'product-details-modal-arrow-clicked',
}
